/* eslint-disable no-console */
import {
	WIDGET_LOAD_ERROR,
	WIDGET_LOADED,
	WIDGET_LOADING,
	WIDGET_HIDDEN,
	// eslint-disable-next-line
	INITIAL_STATE
} from '../actions/widgetStates';
import * as types from '../actions/types';

// Setup widget states
const STATES = {};

STATES[INITIAL_STATE] = {
	state: WIDGET_LOADING,
	nextState: [WIDGET_LOAD_ERROR, WIDGET_LOADED, WIDGET_HIDDEN]
};

STATES[WIDGET_LOAD_ERROR] = {
	state: WIDGET_LOAD_ERROR,
	nextState: []
};

STATES[WIDGET_LOADED] = {
	state: WIDGET_LOADED,
	nextState: []
};

STATES[WIDGET_HIDDEN] = {
	state: WIDGET_HIDDEN,
	nextState: []
};

export default function widgetState(state, action) {
	if (typeof state === 'undefined') {
		return STATES[INITIAL_STATE];
	}

	if (!action.error && action.payload) {
		switch (action.type) {
			case types.SET_WIDGET_STATE:
				if (state.nextState.indexOf(action.payload) !== -1) {
					return STATES[action.payload];
				}
				break;
			case types.LOAD_PRICE:
				if (action.payload && action.payload.price) {
					if (state.nextState.indexOf(WIDGET_LOADED) !== -1) {
						return STATES[WIDGET_LOADED];
					}
				}
				break;
			case types.HIDE_WIDGET:
				return STATES[WIDGET_HIDDEN];
			default:
				break;
		}
	}

	return state;
}
